import React, { useEffect, useState } from "react";
import {
  FaHome,
  FaShoppingCart,
  FaInfoCircle,
  FaUser,
  FaReceipt,
  FaPhone,
  FaTelegram,
  FaInstagram,
  FaLinkedin,
  FaBoxOpen,
  FaHeadset,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaFacebook,
  FaYoutube,
  FaEllipsisH,
} from "react-icons/fa";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";
import logoEtehadie from "../../assets/images/etehadieLogo.png";
import { useDispatch, useSelector } from "react-redux";
import etehadie from "../../assets/images/etehadie.png";
import { emptyCart, removeUser } from "../../Redux/Actions";
import Kasbokar from "../../assets/images/Kasbokar.png";
import Nemad from "../../assets/images/nemad.png";
import Resane from "../../assets/images/resane.png";
import Logofooter from "../../assets/images/logofooter.png";
import MoreMenuDark from "../../assets/images/MoreDark.svg";
import ProductMenuDark from "../../assets/images/ProductDark.svg";
import HomeMenuDark from "../../assets/images/HomeDark.svg";
import ProfileMenuDark from "../../assets/images/ProfileDark.svg";
import ShopMenuDark from "../../assets/images/ShopDark.svg";
import "./Footer.scss";
import "./Responsive.scss";
import { Config } from "../../Config";

const Footer = (props) => {
  const [aboutContent, setAboutContent] = useState();
  const [contact, setContact] = useState();
  const [social, setSocial] = useState();
  const [pages, setPages] = useState([]);
  const [showMBackDrop, setShowMBackDrop] = useState(false);
  const [subMenuLogin, setSubMenuLogin] = useState(false);
  const [moreMenu, setMoreMenu] = useState(false);
  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(async () => {
    /* await axios                 getting social media data like telegram link
      .get(
        "/Contact/GetSocialMedia",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setSocial(result.data.data);
      })
      .catch((error) => {
        console.log("error", error);
      }); */

    await axios
      .get(
        "/Home/GetFooterAbout",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setAboutContent(result.data);
      })
      .catch((error) => {
        console.log("error", error);
      });

    await axios
      .get(
        "/Contact/GetFooterContact",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setContact(result?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });

    await axios
      .get(
        "/Pages/GetAllPages",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setPages(result.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  const badgeHandler = () => {
    let badge = cart.map((item) => item.count);
    return badge.reduce((acc, curr) => acc + curr, 0);
  };

  const gotoPages = (id, title) => {
    props.history.push({
      pathname: `/pages/${title.replaceAll(" ", "-")}`,
      state: { pageId: id },
    });
  };

  const navigationItemHandler = (e, type) => {
    const list = document.querySelectorAll(".list");
    // const indicator = document.querySelector(".indicator");
    // indicator.classList.add("active");
    list.forEach((item) => {
      item.classList.remove("active");
    });
    e.target.classList.add("active");
    switch (type) {
      case "home":
        props.history.push("/");
        setShowMBackDrop(false);
        setSubMenuLogin(false);
        setMoreMenu(false);
        break;
      case "product":
        props.history.push("/products");
        setShowMBackDrop(false);
        setSubMenuLogin(false);
        setMoreMenu(false);
        break;
      case "shop":
        props.history.push("/cart");
        setShowMBackDrop(false);
        setSubMenuLogin(false);
        setMoreMenu(false);
        break;
      case "profile":
        props.history.push("/profile");
        setShowMBackDrop(false);
        setSubMenuLogin(false);
        setMoreMenu(false);
        break;
      case "login":
        props.history.push("/login");
        setShowMBackDrop(false);
        setSubMenuLogin(false);
        setMoreMenu(false);
        break;
      case "blog":
        props.history.push("/blog");
        setShowMBackDrop(false);
        setSubMenuLogin(false);
        setMoreMenu(false);
        break;
      default:
        break;
    }
  };

  return (
    <footer>
      <div className="footer mobile">
        <div className="navigation">
          <ul>
            <li
              className={props.activePage == "home" ? "list active" : "list"}
              onClick={(e) => navigationItemHandler(e, "home")}
            >
              <div className="listItem">
                <span className="icon">
                  <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.6522 6.08732C18.3642 6.65997 18.7822 7.52148 18.7913 8.43515L18.7826 16.4091C18.7826 18.575 17.0268 20.3308 14.8609 20.3308H13.1217C12.0734 20.3308 11.2222 19.4835 11.2174 18.4351V14.8351C11.2174 14.5566 10.9916 14.3308 10.713 14.3308H8.10435C7.96907 14.3308 7.83945 14.3851 7.74461 14.4816C7.64977 14.5781 7.59767 14.7086 7.6 14.8438V16.2178C7.6 16.65 7.24961 17.0004 6.81739 17.0004C6.38517 17.0004 6.03478 16.65 6.03478 16.2178V14.8438C6.03478 14.2927 6.25374 13.764 6.64349 13.3743C7.03324 12.9845 7.56185 12.7656 8.11304 12.7656H10.7217C11.8661 12.7704 12.7913 13.6994 12.7913 14.8438V18.4351C12.7913 18.6176 12.9392 18.7656 13.1217 18.7656H14.9043C16.201 18.7656 17.2522 17.7144 17.2522 16.4178V8.45254C17.2458 8.01128 17.0415 7.59624 16.6957 7.32211L10.687 2.5308C9.92926 1.90701 8.83595 1.90701 8.07826 2.5308L6.14783 3.97428C5.79004 4.23121 5.29172 4.14946 5.03478 3.79167C4.77785 3.43389 4.85961 2.93556 5.21739 2.67863L7.12174 1.29602C8.44214 0.234661 10.3231 0.234661 11.6435 1.29602L17.6522 6.08732ZM3.92174 18.7569H7.92174V18.7743C8.35396 18.7743 8.70435 19.1247 8.70435 19.5569C8.70435 19.9891 8.35396 20.3395 7.92174 20.3395H3.92174C1.75781 20.3347 0.00478219 18.5817 0 16.4178V8.45254C0.0138353 7.53212 0.445876 6.66804 1.17391 6.10471L1.89565 5.56558C2.23552 5.40536 2.64129 5.50929 2.86229 5.81317C3.08329 6.11704 3.05714 6.53509 2.8 6.80906L2.09565 7.3308C1.76191 7.60807 1.56776 8.01866 1.56522 8.45254V16.4091C1.57474 17.7052 2.62562 18.7522 3.92174 18.7569Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <span className="text">خانه</span>
              </div>
            </li>
            <li
              className={props.activePage == "product" ? "list active" : "list"}
              onClick={(e) => navigationItemHandler(e, "product")}
            >
              <div className="listItem">
                <span className="icon">
                  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 5.14706L2.51258 1.79438C2.59342 1.61519 2.77176 1.5 2.96834 1.5H14.7171C14.9002 1.5 15.0687 1.60009 15.1562 1.7609L17 5.14706M1 5.14706H17M1 5.14706V11.8235M17 5.14706V18C17 18.2761 16.7761 18.5 16.5 18.5H9H1.5C1.22386 18.5 1 18.2761 1 18V15.5M7.12766 11.1471L7.39089 11.0561C8.43422 10.6955 9.56754 10.6904 10.6141 11.0414L10.9291 11.1471V5.5L9.85106 2.02941H7.97872L7.12766 5.5V8.32353V11.1471Z"
                      stroke="black"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className="text">محصولات</span>
              </div>
            </li>
            {user.length > 0 && user[0]?.token !== "" ? (
              <>
                <li
                  className={props.activePage == "shop" ? "list active" : "list"}
                  onClick={(e) => navigationItemHandler(e, "shop")}
                >
                  <div className="listItem">
                    <span className="icon">
                      <svg width="19" height="23" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M17 13.5L17.438 17.0039C17.7364 19.3913 15.8749 21.5 13.4689 21.5H5.53113C3.12514 21.5 1.26359 19.3913 1.56202 17.0039L2.56202 9.00386C2.81223 7.00215 4.51384 5.5 6.53113 5.5H12.3471C14.416 5.5 16.1434 7.07754 16.3307 9.13786L16.5 11"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M6.5 8.5V4.3541C6.5 3.21779 7.14201 2.179 8.15836 1.67082V1.67082C9.00294 1.24853 9.99706 1.24853 10.8416 1.67082V1.67082C11.858 2.179 12.5 3.21779 12.5 4.3541V8.5"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>
                    {cart.length > 0 && (
                      <React.Fragment>
                        <span className="badge"> {badgeHandler()} </span>
                      </React.Fragment>
                    )}
                    <span className="text">سبد خرید</span>
                  </div>
                </li>
                <li
                  className={props.activePage == "profile" ? "list active" : "list"}
                  onClick={(e) => navigationItemHandler(e, "profile")}
                >
                  <div className="listItem">
                    <span className="icon">
                      <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.05836 5.85387C4.05836 3.69392 5.82642 1.93696 8 1.93696C10.1736 1.93696 11.9416 3.69392 11.9416 5.85387C11.9416 8.01281 10.1736 9.76977 8 9.76977C5.82642 9.76977 4.05836 8.01281 4.05836 5.85387ZM2.61233 5.85387C2.61233 8.80479 5.02943 11.2067 8 11.2067C10.9706 11.2067 13.3867 8.80479 13.3867 5.85387C13.3867 2.90194 10.9706 0.5 8 0.5C5.02943 0.5 2.61233 2.90194 2.61233 5.85387ZM6.97761 20.485C7.3127 20.495 7.65384 20.5 8 20.5C11.4345 20.5 16 20.119 16 16.8301C16 13.1392 9.97836 13.1392 8 13.1392C4.56553 13.1392 0 13.5202 0 16.8101C0 17.7951 0.460881 19.124 2.6566 19.863C3.03597 19.993 3.44453 19.788 3.57333 19.413C3.70113 19.038 3.49887 18.631 3.1205 18.504C1.61811 17.9981 1.44503 17.2951 1.44503 16.8101C1.44503 15.3271 3.65082 14.5751 8 14.5751C12.3492 14.5751 14.555 15.3341 14.555 16.8301C14.555 18.3121 12.3492 19.063 8 19.063C7.66792 19.063 7.34088 19.059 7.01887 19.05C6.63245 19.053 6.2883 19.351 6.27723 19.747C6.26516 20.144 6.57912 20.475 6.97761 20.485Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <span className="text">پروفایل</span>
                  </div>
                </li>
              </>
            ) : (
              <>
                <li
                  className={props.activePage == "blog" ? "list active" : "list"}
                  onClick={(e) => navigationItemHandler(e, "blog")}
                >
                  <div className="listItem">
                    <span className="icon">
                      <svg width="16" height="21" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.25 1.50001V1.50001C16.7688 1.50001 18 2.73122 18 4.25001L18 6.21429C18 6.48084 18 6.61412 17.9505 6.71694C17.9013 6.819 17.819 6.90134 17.7169 6.95049C17.6141 7 17.4808 7 17.2143 7L12.5 7M15.25 1.50001V1.50001C13.7312 1.50001 12.5 2.73122 12.5 4.25001L12.5 7M15.25 1.50001L5.5 1.50001C3.61438 1.50001 2.67157 1.50001 2.08579 2.08579C1.5 2.67158 1.5 3.61439 1.5 5.50001L1.5 9.75M12.5 7L12.5 15.8373C12.5 16.9013 11.4577 17.6526 10.4483 17.3161V17.3161C9.99503 17.165 9.50497 17.165 9.05169 17.3161L8.375 17.5417C7.48247 17.8392 6.51753 17.8392 5.625 17.5417L4.94831 17.3161C4.49503 17.165 4.00497 17.165 3.55169 17.3161V17.3161C2.54234 17.6526 1.5 16.9013 1.5 15.8373L1.5 13.5"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M5.16675 5.16675L8.83341 5.16675"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path d="M6.08325 8.83325H5.16659" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                        <path d="M5.16675 12.5L7.91675 12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                    </span>
                    <span className="text">بلاگ</span>
                  </div>
                </li>
                <li
                  className={props.activePage == "login" ? "list active" : "list"}
                  onClick={(e) => navigationItemHandler(e, "login")}
                >
                  <div className="listItem">
                    <span className="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.05836 5.85387C4.05836 3.69392 5.82642 1.93696 8 1.93696C10.1736 1.93696 11.9416 3.69392 11.9416 5.85387C11.9416 8.01281 10.1736 9.76977 8 9.76977C5.82642 9.76977 4.05836 8.01281 4.05836 5.85387ZM2.61233 5.85387C2.61233 8.80479 5.02943 11.2067 8 11.2067C10.9706 11.2067 13.3867 8.80479 13.3867 5.85387C13.3867 2.90194 10.9706 0.5 8 0.5C5.02943 0.5 2.61233 2.90194 2.61233 5.85387ZM6.97761 20.485C7.3127 20.495 7.65384 20.5 8 20.5C11.4345 20.5 16 20.119 16 16.8301C16 13.1392 9.97836 13.1392 8 13.1392C4.56553 13.1392 0 13.5202 0 16.8101C0 17.7951 0.460881 19.124 2.6566 19.863C3.03597 19.993 3.44453 19.788 3.57333 19.413C3.70113 19.038 3.49887 18.631 3.1205 18.504C1.61811 17.9981 1.44503 17.2951 1.44503 16.8101C1.44503 15.3271 3.65082 14.5751 8 14.5751C12.3492 14.5751 14.555 15.3341 14.555 16.8301C14.555 18.3121 12.3492 19.063 8 19.063C7.66792 19.063 7.34088 19.059 7.01887 19.05C6.63245 19.053 6.2883 19.351 6.27723 19.747C6.26516 20.144 6.57912 20.475 6.97761 20.485Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <span className="text">ورود</span>
                  </div>
                </li>
              </>
            )}
            <div
              className={
                props.activePage == "home" ||
                props.activePage == "shop" ||
                props.activePage == "product" ||
                props.activePage == "profile" ||
                props.activePage == "login" ||
                props.activePage == "blog"
                  ? "indicator active"
                  : "indicator"
              }
            ></div>
          </ul>
        </div>
      </div>

      <div className="footer desktop">
        <div className="desktop">
          <div className="footerBox">
            <div className="footerItems">
              <p className="title"> درباره ما </p>
              <p className="detail" dangerouslySetInnerHTML={{ __html: aboutContent && aboutContent.content }}></p>
            </div>
            <div className="footerItems">
              <div className="links">
                {pages &&
                  pages.slice(0, 6).map((item, index) => {
                    return (
                      <span onClick={() => gotoPages(item.id, item.title)} key={index} className="link">
                        {item.title}
                      </span>
                    );
                  })}
              </div>
            </div>
            <div className="footerItems">
              <div className="links">
                {pages &&
                  pages.slice(6, 12).map((item, index) => {
                    return (
                      <span onClick={() => gotoPages(item.id, item.title)} key={index} className="link">
                        {item.title}
                      </span>
                    );
                  })}
              </div>
            </div>
            <div className="footerItems">
              <p className="title"> ارتباط با ما </p>
              <div className="links contact">
                <a href={`tel:${contact?.phone}`}>
                  <FaPhone /> {contact && contact?.phone}
                </a>
                <p>
                  <FaMapMarkerAlt /> {contact && contact?.location}
                </p>
                <a href={`mailto:${contact?.email}`}>
                  <FaEnvelope /> {contact && contact?.email}
                </a>
                {/* <div className="socialMedia">
                  {social &&
                    social.map((item, index) => {
                      switch (item.name) {
                        case "تلگرام":
                          return (
                            <a key={index} href={item.link}>
                              <FaTelegram />
                            </a>
                          );
                        case "واتس اپ":
                          return (
                            <a key={index} href={item.link}>
                              <FaWhatsapp />
                            </a>
                          );
                        case "لینکدین":
                          return (
                            <a key={index} href={item.link}>
                              <FaLinkedin />
                            </a>
                          );
                        case "فیسبوک":
                          return (
                            <a key={index} href={item.link}>
                              <FaFacebook />
                            </a>
                          );
                        case "اینستاگرام":
                          return (
                            <a key={index} href={item.link}>
                              <FaInstagram />
                            </a>
                          );
                        case "یوتیوب":
                          return (
                            <a key={index} href={item.link}>
                              <FaYoutube />
                            </a>
                          );
                        default:
                          break;
                      }
                    })}
                </div> */}
                <div className="nemad">
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=330664&amp;Code=ZRtQQYCOR9mkHPw6Ctyu"
                  >
                    <img
                      referrerPolicy="origin"
                      src="https://Trustseal.eNamad.ir/logo.aspx?id=330664&amp;Code=ZRtQQYCOR9mkHPw6Ctyu"
                      alt=""
                      style={{ cursor: "pointer" }}
                      id="ZRtQQYCOR9mkHPw6Ctyu"
                    />
                  </a>
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://logo.samandehi.ir/Verify.aspx?id=344966&p=xlaoaodsaodspfvlgvkagvka"
                  >
                    <img
                      referrerPolicy="origin"
                      id="rgvjwlaowlaosizpfukzfukz"
                      style={{ cursor: "pointer", marginRight: 10 }}
                      //   onClick='window.open("", "Popup","toolbar=no, scrollbars=no, location=no,
                      // statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
                      alt="logo-samandehi"
                      src="https://logo.samandehi.ir/logo.aspx?id=344966&p=qftishwlshwlbsiywlbqwlbq"
                    />
                  </a>
                  <a referrerPolicy="origin" target="_blank" href="https://qr.mojavez.ir/track/1672878">
                    <img
                      style={{ cursor: "pointer", marginRight: 10 }}
                      //   onClick='window.open("", "Popup","toolbar=no, scrollbars=no, location=no,
                      // statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
                      alt="logo-etehadie"
                      src={logoEtehadie}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="copyRight">
              <p> Copyright© 2022 تمامی حقوق مادی و معنوی سایت متعلق به شرکت همسفر بار صدرا (صدرا یار) می‌باشد. </p>
              <a href="/">
                <img src={Logofooter} alt="Logofooter" />
              </a>
              <p>
                طراحی شده توسط:{" "}
                <a href={Config.footerAddress} target="_blank">
                  {Config.footerCompany}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(withRouter(Footer));
